import { z } from 'zod';
import { requiredString } from '../helpers';
export const Strada_Schedule_Check_1_ConfigValidator = z
    .object({
    scheduleId: requiredString('Schedule is required'),
    checkTime: z.enum(['now', 'custom'], {
        error: (issue) => issue.input === undefined ? 'Check time is required' : 'Check time must be either "now" or "custom"'
    }),
    customTimeVariable: z.string().optional()
})
    .refine((data) => {
    if (data.checkTime === 'custom') {
        return data.customTimeVariable !== undefined && data.customTimeVariable.trim().length > 0;
    }
    return true;
}, {
    path: ['customTimeVariable'],
    message: 'Custom time variable is required when check time is "custom"'
});
//# sourceMappingURL=strada-schedule-check-1.js.map